import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost } from '../../lib/api';

export const inspectionsKey = (params) => ['inspections', params || {}];
export const inspectionKey = (id) => ['inspections', id];
export const inspectionJobKey = (id) => ['inspections', id, 'job'];

export function useInspections(params = {}) {
  const q = new URLSearchParams();
  if (params.project_id) q.set('project_id', params.project_id);
  if (params.status) q.set('status', params.status);
  if (params.page) q.set('page', String(params.page));
  if (params.page_size) q.set('page_size', String(params.page_size));
  const qs = q.toString();
  return useQuery({
    queryKey: inspectionsKey(params),
    queryFn: () => apiGet(`/inspections${qs ? `?${qs}` : ''}`),
  });
}

export function useInspection(id) {
  return useQuery({
    queryKey: inspectionKey(id),
    queryFn: () => apiGet(`/inspections/${id}`),
    enabled: Boolean(id),
  });
}

export function useInspectionJob(id, { pollMs = 1500 } = {}) {
  return useQuery({
    queryKey: inspectionJobKey(id),
    queryFn: () => apiGet(`/inspections/${id}/job`),
    enabled: Boolean(id),
    refetchInterval: (q) => {
      const data = q.state.data;
      if (!data) return pollMs;
      return ['succeeded', 'done', 'failed'].includes(data.state) ? false : pollMs;
    },
  });
}

export function useCreateInspection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiPost('/inspections', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['inspections'] }),
  });
}

export function useReprocessInspection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiPost(`/inspections/${id}/reprocess`),
    onSuccess: (_, id) => {
      qc.invalidateQueries({ queryKey: ['inspections'] });
      qc.invalidateQueries({ queryKey: inspectionKey(id) });
    },
  });
}
